import { productOperationTemplateConstants as C } from '../actions/constants'

const initialState = {
    templates: [],
    byProduct: {},
    loading: false,
    error: null,
}

const productOperationTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case C.LIST_REQUEST:
        case C.RESOLVE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            }

        case C.LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                templates: action.payload || [],
            }

        case C.RESOLVE_SUCCESS:
            return {
                ...state,
                loading: false,
                byProduct: {
                    ...state.byProduct,
                    [action.payload.productId]: action.payload.templates || [],
                },
            }

        case C.LIST_FAILURE:
        case C.RESOLVE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }

        default:
            return state
    }
}

export default productOperationTemplateReducer